/**
 * Utility functions for type checking and conversion
 */

/**
 * Checks if a value is a plain object (JSON)
 * @param value The value to check
 * @returns True if the value is a plain object, false otherwise
 */
export const isPlainObject = (value: any): boolean => {
  return (
    typeof value === "object" &&
    value !== null &&
    !Array.isArray(value) &&
    Object.getPrototypeOf(value) === Object.prototype
  );
};

/**
 * Checks if a value is a number or can be parsed as a number
 * @param value The value to check
 * @returns True if the value is a number, false otherwise
 */
export const isNumber = (value: any): boolean => {
  if (typeof value === "number") return true;
  if (typeof value === "string") {
    return !isNaN(Number(value)) && !isNaN(parseFloat(value));
  }
  return false;
};

/**
 * Determines if a permission value is a JSON object or a number
 * @param permission The permission value to check
 * @returns An object indicating the type and the processed value
 */
export const checkPermissionType = (
  permission: any,
): {
  isObject: boolean;
  isNumber: boolean;
  value: any;
} => {
  if (isPlainObject(permission)) {
    return { isObject: true, isNumber: false, value: permission };
  }

  if (isNumber(permission)) {
    const numValue =
      typeof permission === "string" ? Number(permission) : permission;
    return { isObject: false, isNumber: true, value: numValue };
  }

  // Default case if it's neither
  return { isObject: false, isNumber: false, value: permission };
};
